import React, { useState } from 'react'

import {
  pantryColors,
  pantryRadii,
  pantryShadows,
} from '../../../foundations/tokens'

export interface TooltipProps {
  label: React.ReactNode
  children: React.ReactNode
  width?: number | string
  // Extra styles for the hover wrapper (e.g. `maxWidth` so a truncating
  // child can shrink inside a flex row).
  style?: React.CSSProperties
}

export const Tooltip: React.FC<TooltipProps> = ({
  label,
  children,
  width = 230,
  style,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        ...style,
      }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {children}
      <span
        style={{
          position: 'absolute',
          top: 'calc(100% + 8px)',
          left: 0,
          width,
          padding: '9px 12px',
          borderRadius: pantryRadii.md,
          background: pantryColors.gray[800],
          color: pantryColors.white,
          fontSize: 11.5,
          lineHeight: 1.6,
          boxShadow: pantryShadows.lg,
          opacity: open ? 1 : 0,
          pointerEvents: 'none',
          transition: 'opacity 0.18s',
          zIndex: 20,
        }}
      >
        {label}
      </span>
    </span>
  )
}
